/**
 * Karten erst bei Bedarf laden: Leaflet ist das grösste Einzelpaket und wird
 * für Kennzahlen und Diagramme nicht gebraucht.
 */
import { lazy, Suspense, type ComponentProps } from 'react';

const Maps = () => import('./Maps');
const LocatorMapImpl = lazy(() => Maps().then((m) => ({ default: m.LocatorMap })));
const PortfolioMapImpl = lazy(() => Maps().then((m) => ({ default: m.PortfolioMap })));

type LocatorProps = ComponentProps<typeof import('./Maps').LocatorMap>;
type PortfolioProps = ComponentProps<typeof import('./Maps').PortfolioMap>;

export function LocatorMap(p: LocatorProps) {
  return (
    <Suspense fallback={<div className="skeleton" style={{ height: p.height ?? 240 }} />}>
      <LocatorMapImpl {...p} />
    </Suspense>
  );
}

export function PortfolioMap(p: PortfolioProps) {
  return (
    <Suspense fallback={<div className="skeleton" style={{ height: p.height ?? 420 }} />}>
      <PortfolioMapImpl {...p} />
    </Suspense>
  );
}
